import type { JSX } from "react";
import { cn } from "@/lib/utils";

function Skeleton({
  role = "status",
  "aria-label": ariaLabel = "Loading",
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: The dynamic role defaults to status and callers control its accessible name.
    <div
      aria-label={ariaLabel}
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      role={role}
      {...props}
    />
  );
}

export { Skeleton };
